import styled from 'styled-components';

import { getStatusColor } from '@/entities/vfo/helpers';
import { UserStatus } from '@/entities/vfo/types';

export const DotColorByStatus = ({
  status,
  isVfoActivated,
}: {
  status: UserStatus;
  isVfoActivated: boolean;
}) => {
  return <Dot style={{ backgroundColor: getStatusColor(status, isVfoActivated) }} />;
};

const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
`;
